import BookCollection from './BookCollections'

export default BookCollection
